import React from 'react';
import { AdvertorialHeader } from './AdvertorialHeader';
import { UrgencyBanner } from './UrgencyBanner';
import { HeroSection } from './HeroSection';
import { ArticleContent } from './ArticleContent';
import { CommentSection } from './CommentSection';
import { StickyFooterCTA } from './StickyFooterCTA';
import { SidebarCTA } from './SidebarCTA';
export function AdvertorialPage() {
  return <div className="min-h-screen bg-white advertorial-body" data-id="element-7">
      <AdvertorialHeader data-id="element-8" />
      <UrgencyBanner data-id="element-9" />

      <div className="max-w-7xl mx-auto px-4 py-8 md:py-10" data-id="element-10">
        <div className="flex gap-8" data-id="element-11">
          {/* Main Content */}
          <main className="flex-1 max-w-3xl" data-id="element-12">
            <HeroSection data-id="element-13" />
            <ArticleContent data-id="element-14" />
            <CommentSection data-id="element-15" />
          </main>

          {/* Right Sidebar CTA - Desktop Only */}
          <SidebarCTA data-id="element-16" />
        </div>
      </div>

      <footer className="bg-gray-100 py-8 border-t border-gray-200 pb-24" data-id="element-17">
        <div className="max-w-3xl mx-auto px-4 text-center text-gray-500 text-xs" data-id="element-18">
          {/* Recommended sidebar for mobile */}
          <div className="lg:hidden mb-8 p-4 bg-white rounded-lg border border-gray-200" data-id="element-19">
            <h3 className="font-bold text-gray-900 mb-4" data-id="element-20">Recommended</h3>
            <img src="https://cdn.magicpatterns.com/uploads/nGwAxHcNKpi2Sk9GY8YVmY/ChatGPT_Image_5_Φεβ_2026,_03_33_50_μ.μ..png" alt="Nymera Lymphatic Drainage Softgels" className="w-full max-w-xs mx-auto rounded-lg mb-4" data-id="element-21" />
            <a href="https://trynymera.com/products/nymera-lymphatic-drainage-softgels" className="block w-full bg-[#0d5d55] hover:bg-[#0a4a44] text-white font-bold py-3 px-4 rounded-lg" data-id="element-22">
              GET 30% OFF NYMERA NOW!
            </a>
          </div>

          <p className="mb-4" data-id="element-23">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease. Individual results may vary. Please
            consult your healthcare provider before beginning any supplement
            program.
          </p>
          <p className="mb-6 font-semibold" data-id="element-24">
            THIS IS AN ADVERTORIAL AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
            CONSUMER PROTECTION UPDATE
          </p>
          <p data-id="element-25">© {new Date().getFullYear()} Nymera. ALL RIGHTS RESERVED.</p>
        </div>
      </footer>

      <StickyFooterCTA data-id="element-26" />
    </div>;
}